import React, { useEffect, useState } from "react";
import { functionService } from "../../lib/functions";
import style from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import Sidemenu from "../../components/sidemenu";
import Header from "../../components/header";


function ConfirmDemand() {
  console.log("I was here");
  let navigate = useNavigate();
  useEffect(() => {

    // const getToken = localStorage.getItem("jwtToken");
    // if (getToken) {
    //   navigate(`/demand-form`, { replace: true });
    //   // Router.replace("/assessment-question");
    // }
  }, []);

  const [errorResponse, updateerrorResponse] = useState(null);

  const signInHandler=async ()=>{
      navigate(`/demand-table`, { replace: true });
  }

  return (
    <div>
      <Header />
      <Sidemenu />
      <React.Fragment >
        <div className={style.containerset} >
          <div className={style.loginArea} style={{background:"white"}}>
            <div className="image">

              <img src="./coffeee_logo.svg" height="100" width="100" />
            </div>{errorResponse != null ?
              <div className={style.errorMsg}>{errorResponse}
              </div> : ""
            }
            <div className={style.formStructure}>
              <p>
                Your demand response has been submitted successfully.
              </p>
            </div>
            <button onClick={signInHandler}>Go Back</button>
          </div>
        </div>
        {/* <button  onClick={() =>  loginButtonHandler()}>Log In</button> */}
      </React.Fragment>

    </div>
  );
}

export default ConfirmDemand;
